import { render, staticRenderFns } from "./IconSvgFacebook.vue?vue&type=template&id=5bd0e74e&scoped=true&"
import script from "./IconSvgFacebook.vue?vue&type=script&lang=js&"
export * from "./IconSvgFacebook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd0e74e",
  null
  
)

export default component.exports